import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function usePrepareMail({ enterpriseId }) {
  const [emailData, setEmailData] = useState(null);

  useEffect(() => {
    if (enterpriseId) {
      axios
        .get(routes.api.slack.setupPrepare, {
          params: {
            enterprise_id: enterpriseId,
          },
        })
        .then((response) => {
          setEmailData(response.data.data);
        }).catch(() => {

        });
    }
  }, [enterpriseId]);

  return emailData;
}
